import axios from 'axios';
import { api } from "./api";



api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Or AsyncStorage for mobile
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const gatepassList = async (id) => {
if (id) {
    return await api.get(`gatepass/list?id=${id}`);
} else {
    return await api.get('gatepass/list');
}
};
export const gatepassadd = async (data) => {
  return await api.post('gatepass/add',data);
};

export const gatepassUpdata = async (data) => {
  return await api.post('gatepass/update',data);
};
export const gatepassdelete = async (id) => {
  return await api.get(`gatepass/delete/${id}`,);
};

